import { Actions, Effect, ofType } from '@ngrx/effects';
import { InstantWebsiteDataService } from './instant-website-data.service';
import {
  ActionsEnum,
  FetchInstantWebsiteSettingsError,
  fetchInstantWebsiteSettingsError,
  FetchInstantWebsiteSettingsSuccess,
  fetchInstantWebsiteSettingsSuccess,
  SaveInstantWebsiteSettingsNetwork,
  saveInstantWebsiteSettingsNetworkError,
  SaveInstantWebsiteSettingsNetworkError,
  saveInstantWebsiteSettingsNetworkSuccess,
  SaveInstantWebsiteSettingsNetworkSuccess,
} from './instant-website.actions';
import { catchError, map, switchMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { GlobalBannerService } from '../shared/components/global-banner/global-banner.service';
import { Observable, of } from 'rxjs';
import { I2gDialogService, ToastService } from 'i2g-ng-ui';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class InstantWebsiteDataEffects {
  constructor(
    private _actions: Actions,
    private _instantWebsiteDataService: InstantWebsiteDataService,
    private _globalBannerService: GlobalBannerService,
    private _dialogService: I2gDialogService,
    private _toastService: ToastService,
    private _translateService: TranslateService
  ) {}

  @Effect()
  fetchInstantWebsiteSettings(): Observable<
    FetchInstantWebsiteSettingsSuccess | FetchInstantWebsiteSettingsError
  > {
    return this._actions.pipe(
      ofType(ActionsEnum.FETCH_INSTANT_WEBSITE_SETTINGS),
      switchMap(() => {
        return this._instantWebsiteDataService
          .fetchInstantWebsiteSettings()
          .pipe(
            map((settings) => fetchInstantWebsiteSettingsSuccess(settings)),
            catchError((error) => {
              this._globalBannerService.showSystemErrorBanner(error);
              return of(fetchInstantWebsiteSettingsError(error));
            })
          );
      })
    );
  }

  @Effect()
  saveInstantWebsiteSettings(): Observable<
    | SaveInstantWebsiteSettingsNetworkSuccess
    | SaveInstantWebsiteSettingsNetworkError
  > {
    return this._actions.pipe(
      ofType(ActionsEnum.SAVE_INSTANT_WEBSITE_SETTINGS_NETWORK),
      switchMap(({ payload }: SaveInstantWebsiteSettingsNetwork) => {
        return this._instantWebsiteDataService
          .saveInstantWebsiteSettings(payload)
          .pipe(
            map((settings) => {
              this._toastService.show(
                this._translateService.instant('LABEL.CHANGES_SAVED')
              );
              return saveInstantWebsiteSettingsNetworkSuccess(settings);
            }),
            catchError((error) => {
              this._globalBannerService.showSystemErrorBanner(error);
              return of(saveInstantWebsiteSettingsNetworkError(error));
            })
          );
      })
    );
  }
}
